import { dictionaryApi } from './dictionaryClient';

export type Upasarga = {
  id: number;
  name: string;
  description?: string | null;
};

export type CreateUpasargaBody = {
  name: string;
  description?: string | null;
};

export type PatchUpasargaBody = Partial<Pick<Upasarga, 'name' | 'description'>>;

function normalizeList(data: unknown): Upasarga[] {
  if (Array.isArray(data)) return data as Upasarga[];
  if (data && typeof data === 'object' && Array.isArray((data as { data?: unknown }).data)) {
    return (data as { data: Upasarga[] }).data;
  }
  return [];
}

export async function listUpasargas(): Promise<Upasarga[]> {
  const res = await dictionaryApi.get<unknown>('/upasarga');
  return normalizeList(res.data);
}

export async function getUpasarga(id: number): Promise<Upasarga> {
  const res = await dictionaryApi.get<Upasarga>(`/upasarga/${id}`);
  return res.data;
}

function normDesc(s: string | null | undefined): string | null {
  if (s == null) return null;
  const t = String(s).trim();
  return t === '' ? null : t;
}

export async function createUpasarga(body: CreateUpasargaBody): Promise<Upasarga> {
  const payload: { name: string; description?: string | null } = { name: body.name.trim() };
  const d = normDesc(body.description);
  if (d != null) payload.description = d;
  const res = await dictionaryApi.post<Upasarga>('/upasarga', payload);
  return res.data;
}

export async function updateUpasarga(id: number, body: PatchUpasargaBody): Promise<Upasarga> {
  const payload: PatchUpasargaBody = {};
  if (body.name !== undefined) payload.name = body.name.trim();
  if (body.description !== undefined) payload.description = normDesc(body.description as string);
  const res = await dictionaryApi.patch<Upasarga>(`/upasarga/${id}`, payload);
  return res.data;
}

export async function deleteUpasarga(id: number): Promise<void> {
  await dictionaryApi.delete(`/upasarga/${id}`);
}

/** Build a PATCH body from form vs previous row. */
export function buildUpasargaPatch(
  prev: Upasarga,
  next: { name: string; description: string }
): PatchUpasargaBody {
  const patch: PatchUpasargaBody = {};
  if (prev.name !== next.name.trim()) patch.name = next.name.trim();
  const pd = normDesc(prev.description);
  const nd = normDesc(next.description);
  if (pd !== nd) patch.description = nd;
  return patch;
}
